import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "../select/Select";
import { FirmaRelationKodeDict } from "../wizards/OpretPerson/useOpretPerson";
import IsRequired from "./common/IsRequired";

export type FirmaRelationKode = "Ansat" | "Partner" | "Ejer";
const isFirmaRelationKode = (value: string): value is FirmaRelationKode => {
  return value === "Ansat" || value === "Partner" || value === "Ejer";
};

export default function PersonFirmaRelationSelect(props: {
  currentValue: FirmaRelationKode;
  setValue: (value: FirmaRelationKode) => void;
}) {
  const { currentValue, setValue } = props;

  return (
    <Select
      value={currentValue}
      onValueChange={(val) => {
        if (isFirmaRelationKode(val)) setValue(val);
      }}
    >
      <label className="form-label">
        {"Firmarelation"} <IsRequired />
      </label>
      <SelectTrigger />
      <SelectContent>
        <SelectItem value={FirmaRelationKodeDict.ansat.kode.toString()}>
          {FirmaRelationKodeDict.ansat.beskrivelse}
        </SelectItem>
        <SelectItem value={FirmaRelationKodeDict.partner.kode.toString()}>
          {FirmaRelationKodeDict.partner.beskrivelse}
        </SelectItem>
        <SelectItem value={FirmaRelationKodeDict.ejer.kode.toString()}>
          {FirmaRelationKodeDict.ejer.beskrivelse}
        </SelectItem>
      </SelectContent>
    </Select>
  );
}
